(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const data = JSON.parse(root.querySelector('[data-sample-review-data]').textContent);
    const reviews = data[root.dataset.rasSamples] || [];
    const list = root.querySelector('[data-sample-list]');
    const more = root.querySelector('[data-sample-more]');
    root.querySelector('[data-sample-count]').textContent =
      reviews.length + ' sample reviews · ' + reviews.filter(review => review.photo).length + ' with sample photos';
    let shown = 0;
    function appendReviews() {
      const end = Math.min(shown + 9, reviews.length);
      for (const review of reviews.slice(shown, end)) {
        const card = document.createElement('article');
        card.className = 'ras-samples__card';
        const name = document.createElement('b');
        name.textContent = review.name;
        const stars = document.createElement('span');
        stars.className = 'ras-samples__stars';
        stars.setAttribute('aria-label', review.rating + ' out of 5 sample rating');
        stars.textContent = '★'.repeat(review.rating) + '☆'.repeat(5 - review.rating);
        const copy = document.createElement('p');
        copy.textContent = review.text;
        if (review.lang) { copy.lang = review.lang; copy.dir = 'rtl'; }
        card.append(name, stars, copy);
        if (review.photo) {
          const image = new Image(160, 160);
          image.loading = 'lazy';
          image.src = root.dataset.assetBase + review.photo;
          image.alt = 'Sample Birthflower product photo';
          card.append(image);
        }
        list.append(card);
      }
      shown = end;
      more.hidden = shown >= reviews.length;
    }
    more.addEventListener('click', appendReviews);
    appendReviews();
  }
  document.querySelectorAll('[data-ras-samples]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-ras-samples]').forEach(init));
})();
